import request from '@/service/request';

export const UpdateQuote = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
  data: any,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}`,
    {
      method: 'put',
      data,
    },
  );
};

export const CreateShare = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}/share`,
    {
      method: 'post',
    },
  );
};

export const QuotationConfirm = (
  productType: string,
  productKey: string,
  planKey: string,
  quotationId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation/${quotationId}/state`,
    {
      method: 'put',
    },
  );
};
